import { observer, useLocalObservable } from "mobx-react"
import { Flex } from "antd"

import { GlobalChargesCollection } from "@src/pages/transactionsIn/classes/ChargesCollection"
import { TransactionInTable } from "@src/pages/transactionsIn/ui/TransactionInTable"
import { TableFilters } from "@src/shared/componemts/TableFilter"

export const TransactionsInPage = observer(() => {
  const charges = useLocalObservable(() => GlobalChargesCollection())

  return (
    <Flex gap={16} vertical>
      <TableFilters {...charges.filter.props} />

      <TransactionInTable collection={charges} />
    </Flex>
  )
})
